import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { createAppInitActions } from './app-init.actions'
import { appInitInitialState } from './app-init.slice'
import type { AppInitStore } from './app-init.type'

export const useAppInitStore = create<AppInitStore>()(
  devtools(
    immer((set) => ({
      ...appInitInitialState,
      ...createAppInitActions(set),
    })),
    {
      name: StoreDevtoolsName.AppInit,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
